import React, { useEffect, useState } from "react";
import GridContainer from "@jumbo/components/GridContainer";
import { Box, Grid, Paper } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { makeStyles } from "@material-ui/core/styles";
import VpnKeyIcon from "@material-ui/icons/VpnKey";
import DateRangeIcon from "@material-ui/icons/DateRange";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import CancelPresentationIcon from "@material-ui/icons/CancelPresentation";
import PermIdentityIcon from "@material-ui/icons/PermIdentity";
import DescriptionIcon from "@material-ui/icons/Description";
import ReceiptIcon from "@material-ui/icons/Receipt";
import AvTimerIcon from "@material-ui/icons/AvTimer";
import moment from "jalali-moment";
import NewsRequests from "services/news";
import { Button } from "@mui/material";
import CustomDialog from "../AccessList/CustomDialog";

const useStyles = makeStyles((theme) => ({
  formTitleContainer: {
    padding: "1rem",
    fontWeight: "bold",
    fontSize: "17px",
    color: theme.palette.primary.main,
  },
  Title: {
    padding: "0.8rem",
    backgroundColor: theme.palette.grey[200],
    fontWeight: "bold",
  },
  userInput: {
    padding: "0.8rem",
    fontWeight: "bold",
    minHeight: "45.61px",
  },
  userInputLink: {
    display: "block",
    padding: "0.8rem",
  },
}));

const PurchaseDetailsContainer = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { singlePurchase } = useSelector(({ news }) => news);
  const { id } = useParams();

  const [openRemoveDialog, setOpenRemoveDialog] = useState(false);
  const [openReciveDialog, setOpenReciveDialog] = useState(false);

  useEffect(() => {
    dispatch(NewsRequests.getSinglePurchaseById(id));
  }, [id, dispatch]);

  return (
    <>
      <GridContainer>
        <Grid item md={8} xs={12}>
          <Paper>
            <Box className={classes.formTitleContainer}>
              {singlePurchase?.item?.name}
            </Box>
            <Box className={classes.Title}>توضیحات :</Box>
            <Box
              className={classes.userInput}
              dangerouslySetInnerHTML={{
                __html: singlePurchase?.item?.description,
              }}
            ></Box>
            <Box className={classes.Title}>قیمت :</Box>
            <Box className={classes.userInput}>
              {singlePurchase?.item?.price}
            </Box>
            <Box className={classes.Title}>موجودی :</Box>
            <Box className={classes.userInput}>
              {singlePurchase?.item?.inventory}
            </Box>
            <Box className={classes.Title}>نام ونام خانوادگی :</Box>
            <Box className={classes.userInput}>
              {singlePurchase?.owner?.fullName}
            </Box>
            <Box className={classes.Title}>کد ملی :</Box>
            <Box className={classes.userInput}>
              {singlePurchase?.owner?.nationalCode}
            </Box>
            <Box className={classes.Title}>کد پرسنلی :</Box>
            <Box className={classes.userInput}>
              {singlePurchase?.owner?.personnelCode}
            </Box>
            <Box className={classes.Title}>شماره تلفن :</Box>
            <Box className={classes.userInput}>
              {singlePurchase?.owner?.phone}
            </Box>
          </Paper>
        </Grid>
        <Grid item md={4} xs={12}>
          <Paper elevation={3}>
            <Box className={classes.formTitleContainer}>جزئیات خرید</Box>
            <Box className={classes.Title}>
              <Box display={"flex"} alignItems={"center"}>
                <VpnKeyIcon style={{ marginLeft: "5px" }} />
                شناسه خرید:
              </Box>
            </Box>
            <Box className={classes.userInput} textAlign={"right"}>
              {singlePurchase?._id}
            </Box>
            <Box className={classes.Title}>
              <Box display={"flex"} alignItems={"center"}>
                <AttachMoneyIcon style={{ marginLeft: "5px" }} />
                قیمت خرید:
              </Box>
            </Box>
            <Box className={classes.userInput} textAlign={"right"}>
              {singlePurchase?.purchasePrice}
            </Box>
            <Box className={classes.Title}>
              <Box display={"flex"} alignItems={"center"}>
                <DateRangeIcon style={{ marginLeft: "5px" }} />
                تاریخ خرید :
              </Box>
            </Box>
            <Box className={classes.userInput} textAlign={"right"}>
              {singlePurchase
                ? moment(singlePurchase.createdAt)
                    .locale("fa")
                    .format("HH:mm:ss  YYYY/MM/DD ")
                : null}
            </Box>
            <Box className={classes.Title}>
              <Box display={"flex"} alignItems={"center"}>
                <DeleteForeverIcon style={{ marginLeft: "5px" }} />
                حذف شده :
              </Box>
            </Box>
            <Box className={classes.userInput}>
              {singlePurchase?.item?.removed ? "بله" : "خیر"}
            </Box>
            <Box className={classes.Title}>
              <Box display={"flex"} alignItems={"center"}>
                <CancelPresentationIcon style={{ marginLeft: "5px" }} />
                لغو شده :
              </Box>
            </Box>
            <Box className={classes.userInput}>
              {singlePurchase?.removed ? "بله" : "خیر"}
            </Box>
            <Box className={classes.Title}>
              <Box display={"flex"} alignItems={"center"}>
                <AvTimerIcon style={{ marginLeft: "5px" }} />
                منقضی شده :
              </Box>
            </Box>
            <Box className={classes.userInput}>
              {singlePurchase?.expired ? "بله" : "خیر"}
            </Box>
            <Box className={classes.Title}>
              <Box display={"flex"} alignItems={"center"}>
                <ReceiptIcon style={{ marginLeft: "5px" }} />
                دریافت شده :
              </Box>
            </Box>
            <Box className={classes.userInput}>
              {singlePurchase?.attended ? "بله" : "خیر"}
            </Box>
            {singlePurchase?.attendantName && (
              <>
                <Box className={classes.Title}>
                  <Box display={"flex"} alignItems={"center"}>
                    <PermIdentityIcon style={{ marginLeft: "5px" }} />
                    نام متصدی :
                  </Box>
                </Box>
                <Box className={classes.userInput}>
                  {singlePurchase?.attendantName}
                </Box>
              </>
            )}
            {singlePurchase?.attendantDescription && (
              <>
                <Box className={classes.Title}>
                  <Box display={"flex"} alignItems={"center"}>
                    <DescriptionIcon style={{ marginLeft: "5px" }} />
                    توضیحات متصدی :
                  </Box>
                </Box>
                <Box className={classes.userInput}>
                  {singlePurchase?.attendantDescription}
                </Box>
              </>
            )}
            {!singlePurchase?.attended && !singlePurchase?.removed && (
              <Box className={classes.userInput} textAlign={"right"}>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={() => setOpenReciveDialog(true)}
                >
                  دریافت جایزه
                </Button>
              </Box>
            )}
            {!singlePurchase?.removed && !singlePurchase?.attended && (
              <Box className={classes.userInput} textAlign={"right"}>
                <Button
                  variant="contained"
                  color="error"
                  fullWidth
                  onClick={() => setOpenRemoveDialog(true)}
                >
                  حذف خرید
                </Button>
              </Box>
            )}
          </Paper>
        </Grid>
      </GridContainer>
      <CustomDialog
        open={openRemoveDialog}
        handleClose={() => setOpenRemoveDialog(false)}
        text={"آیا از حذف این خرید مطمئن هستید؟"}
        action={() => {
          dispatch(NewsRequests.removePurchase(id));
          setOpenRemoveDialog(false);
        }}
      />
      <CustomDialog
        open={openReciveDialog}
        handleClose={() => setOpenReciveDialog(false)}
        text={"آیا از دریافت جایزه مطمئن هستید؟"}
        action={() => {
          dispatch(NewsRequests.attendPurchase(id));
          setOpenReciveDialog(false);
        }}
      />
    </>
  );
};

export default PurchaseDetailsContainer;
